import React, { PropsWithChildren } from "react";

import * as S from "./styles";

type InputWrapperProps = {
  label?: string;
  isRequired?: boolean;
  error?: string;
  name: string;
};

export const InputWrapper = ({
  label,
  isRequired,
  error,
  name,
  children,
  ...rest
}: PropsWithChildren<InputWrapperProps>) => {
  const shouldShowErrorMessage = !!error;

  return (
    <S.InputWithErrorWrapper {...rest}>
      {label && (
        <S.Label htmlFor={name}>
          {label}
          {isRequired && <S.RequiredSpan>*</S.RequiredSpan>}
        </S.Label>
      )}
      {children}
      {shouldShowErrorMessage && <S.ErrorMessage>{error}</S.ErrorMessage>}
    </S.InputWithErrorWrapper>
  );
};
